export default __webpack_public_path__ + "static/media/mui.fab4e70b.svg";